import { action, makeObservable, observable } from 'mobx';
import * as utils from '../../helpers/utils';

class Settings {
  _id;

  @observable User; // ref Contact

  @observable SelectedChannel; // ref Channel

  @observable MuteSounds;

  @observable PersistentNotifications;

  @observable PersistentNotificationMessages;

  @observable SnoozeNotificationsUntil;

  @observable ShowHiddenMessages;

  @observable HiddenChannels;

  @observable HiddenMessages;

  @observable FilterRecentMessagesFrom;

  constructor(incObject, store) {
    makeObservable(this);

    this._id = incObject._id ? incObject._id : utils.generateGuid();
    this.User = store.contactStore.UpsertAndGet(incObject.User) || null;
    this.SelectedChannel = store.channelStore.UpsertAndGet(incObject.SelectedChannel) || null;
    this.MuteSounds = incObject.MuteSounds || false;
    this.PersistentNotifications = incObject.PersistentNotifications || false;
    this.PersistentNotificationMessages = incObject.PersistentNotificationMessages
      ? store.messageStore.UpsertAndGet(incObject.PersistentNotificationMessages)
      : [];
    this.SnoozeNotificationsUntil = incObject.SnoozeNotificationsUntil || null;
    this.ShowHiddenMessages = incObject.ShowHiddenMessages || false;
    this.HiddenChannels = incObject.HiddenChannels || [];
    this.HiddenMessages = incObject.HiddenMessages || [];
    this.FilterRecentMessagesFrom = incObject.FilterRecentMessagesFrom || null;
  }

  /* eslint-disable */
  @action static UpdateObject(incObject, oldObject, rootStore) {
    oldObject.User = rootStore.contactStore.UpsertAndGet(incObject.User);
    oldObject.SelectedChannel = rootStore.channelStore.UpsertAndGet(incObject.SelectedChannel);
    oldObject.MuteSounds = incObject.MuteSounds;
    oldObject.PersistentNotifications = incObject.PersistentNotifications;
    oldObject.PersistentNotificationMessages = rootStore.messageStore.UpsertAndGet(
      incObject.PersistentNotificationMessages
    );
    oldObject.SnoozeNotificationsUntil = incObject.SnoozeNotificationsUntil;
    oldObject.ShowHiddenMessages = incObject.ShowHiddenMessages;
    oldObject.HiddenChannels = incObject.HiddenChannels;
    oldObject.HiddenMessages = incObject.HiddenMessages;
    oldObject.FilterRecentMessagesFrom = incObject.FilterRecentMessagesFrom;

    return oldObject;
  }
  /* eslint-enable */
}

export default Settings;
